import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="determinants-info"
        path="/determinants-info"
        component={Page} />
];

export default Routes;